export default function anonymous(props
/*``*/) {
var out='<div> <div class="'+(props.styles.title)+' '+(props.themeStyles.titleText)+'" data-hook="video-title"></div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./default-modules/ui/title/templates/title.dot
// module id = 177
// module chunks = 0 1 2 3 4